var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTlgrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "10px",
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-soc-telegram-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.000000, -42.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.569447854,3.73587104 L10.0895052,0.0652594675 C10.5313609,-0.0943681148 10.9172647,0.173049227 10.7740936,0.841181169 L10.7749164,0.840358347 L9.15395593,8.4769748 C9.03382383,9.01839206 8.7121002,9.15004368 8.26201624,8.89496867 L5.79354847,7.07570793 L4.60292419,8.22272262 C4.47127257,8.35437423 4.36019152,8.46545528 4.10511652,8.46545528 L4.28037773,5.95337792 L8.85527133,1.82034005 C9.05439439,1.64507884 8.81083891,1.54634013 8.5483585,1.72077852 L2.89474449,5.28030904 L0.457543982,4.52002097 C-0.0715309431,4.35216516 -0.0830504594,3.99094604 0.569447854,3.73587104 Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlgrm);
export default ForwardRef;